import React from 'react';
import styled from '@emotion/styled';
import { BsPlus } from '@react-icons/all-files/bs/BsPlus';
import { useContextSelector } from 'use-context-selector';
import { BucketLogData } from '@bucketplace/bucket-log';

import { EditorPlaceholder } from '../../../components/EditorPlaceholder';
import { EditorContext, useEditorInfoContext } from '../../../contexts';
import { DocumentPath } from '../../../types';
import { useTabContext } from '../Tab';

export interface TabButtonProps {
  children: React.ReactNode;
  state: 'on' | 'off';
  index: number;
  path: DocumentPath;
  logData?: BucketLogData;
}

export function TabButton({ children, state, index, path, logData }: TabButtonProps) {
  const { selectIndex } = useTabContext();

  const { handleClickInEditor } = useEditorInitializer({ path });
  const { onSendLog } = useEditorInfoContext();
  function handleMouseDown(e: React.MouseEvent) {
    e.stopPropagation();
    selectIndex(index);
    if (logData) {
      onSendLog?.(logData);
    }
    handleClickInEditor?.();
  }

  return (
    <Button type="button" onMouseDownCapture={handleMouseDown}>
      { children || <Placeholder timid={state === 'off'} icon={<BsPlus />} /> }
    </Button>
  );
}

function useEditorInitializer({ path }: { path: DocumentPath }) {
  const context = useContextSelector(EditorContext, (context) => context);
  const isInEditor = !!context;

  function moveCursorToOnButton() {
    context?.setState((state) => ({
      ...state,
      cursor: [...path.slice(0, -1), 0],
    }));
  }

  return {
    handleClickInEditor: isInEditor ? moveCursorToOnButton : undefined,
  };
}

const Placeholder = styled(EditorPlaceholder)<{ timid: boolean }>`
  padding: 10px 0;
  ${({ timid }) => timid && 'opacity: .4;'}
`;

const Button = styled.button`
  width: 100%;
  padding: 0;
  border: none;
  background: none;
`;
